import { Injectable } from '@angular/core';
import { Transport } from '../models/transport.model';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private TRANSPORT_SAVE_DURING_ACCOUNT_CREATION = 'TRANSPORT_SAVE_DURING_ACCOUNT_CREATION';

  public saveTransportForAccountCreation(transport: Transport): void {
    localStorage.setItem(this.TRANSPORT_SAVE_DURING_ACCOUNT_CREATION, JSON.stringify(transport));
  }

  public clearTransportForAccountCreation(): void {
    localStorage.removeItem(this.TRANSPORT_SAVE_DURING_ACCOUNT_CREATION);
  }

  public loadTransportForAccountCreation(): Transport {
    return JSON.parse('' + localStorage.getItem(this.TRANSPORT_SAVE_DURING_ACCOUNT_CREATION)) as Transport;
  }
}
